module.exports = __webpack_public_path__ + "img/unchecked-checkbox.cdf87e78.svg";